"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var React = _interopRequireWildcard(_react);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function SvgShow(props) {
    return React.createElement(
        "svg",
        Object.assign({
            xmlns: "http://www.w3.org/2000/svg",
            width: 24,
            height: 24,
            viewBox: "0 0 24 24",
            fill: "currentColor"
        }, props),
        React.createElement(
            "g",
            { fill: "none", fillRule: "evenodd" },
            React.createElement("path", {
                fill: "currentColor",
                d: "M19 10.021a1 1 0 0 1-1-1V7.42l-3.29 3.294a1.024 1.024 0 0 1-1.436 0 .995.995 0 0 1 0-1.418l3.281-3.286h-1.57a1.005 1.005 0 0 1 0-2.01h3.016A2 2 0 0 1 20 5.992v3.022a1 1 0 0 1-1 1.007zM7.441 17.99H9A1.005 1.005 0 0 1 9 20H6a2 2 0 0 1-2-2.001v-3.022a1 1 0 1 1 2 0v1.601l3.275-3.294a1.015 1.015 0 0 1 1.429 0 1 1 0 0 1 0 1.418L7.441 17.99z"
            })
        )
    );
}
exports.default = SvgShow;